import { render } from "./ChatWindow.vue?vue&type=template&id=13380662"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=13380662&lang=scss"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__